import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fromPassLimits, LocationActivePasses } from 'app/models/LocationActivePasses';
import { LocationsService } from 'app/services/locations.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { pickTruthy } from 'Util';
import { receiveUpdate } from '../live-updates/live-updates.actions';
import * as LocationActivePassesActions from './location-active-passes.actions';

@Injectable()
export class LocationActivePassesEffects {
	constructor(private actions$: Actions, private locationService: LocationsService) {}

	loadLocationActivePasses$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LocationActivePassesActions.loadLocationActivePasses),
			switchMap(() =>
				this.locationService.getPassLimit().pipe(
					map(({ pass_limits }) => pass_limits.map(fromPassLimits)),
					map((locationActivePasses) => LocationActivePassesActions.loadLocationActivePassesSuccess({ data: locationActivePasses })),
					catchError((error: unknown) => of(LocationActivePassesActions.loadLocationActivePassesFailure({ error })))
				)
			)
		)
	);

	receiveUpdate$ = createEffect(() =>
		this.actions$.pipe(
			ofType(receiveUpdate),
			map((action) => {
				if (action.event.action !== 'location.active_pass_counts') {
					return null;
				}
				const parsed = LocationActivePasses.safeParse(action.event.data);
				if (!parsed.success) {
					return null;
				}
				return LocationActivePassesActions.receiveLiveLocationActivePasses({ data: parsed.data });
			}),
			pickTruthy()
		)
	);
}
